import { Navigate } from 'react-router-dom'

import { AvailableModules } from 'generated/featureDefinitions'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import { useEngagementContext } from 'modules/engagement/hooks/useEngagementContext'
import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'
import { UpsellingKit } from 'modules/upselling_kit/components'
import coursesBackground from 'modules/upselling_kit/lib/assets/blankSlate/locked-courses-bg.svg'

const Upsell = () => {
  const { navigation } = useNavigation()

  const { upsellFlowEnabled } = useEngagementContext()

  if (!upsellFlowEnabled) {
    return <Navigate to={navigation.engagement.pulse.fullPath()} />
  }

  return (
    <UpsellingKit.EmptyState
      moduleRequested={AvailableModules.engagement_insights}
      requestSource="Engagement main tabs"
      requestReason={ValidReasons.MissingAddon}
      background={coursesBackground}
      title={i18n.t('engagement_insights.upsell.title')}
      description={i18n.t('engagement_insights.upsell.description')}
    />
  )
}

export default Upsell
